import script from "./LbrxProductSelectionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LbrxProductSelectionModal.vue?vue&type=script&setup=true&lang=ts"

import "./LbrxProductSelectionModal.vue?vue&type=style&index=0&id=2787d9fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2787d9fb"]])

export default __exports__